
import BadgesView from 'common-views/BadgesView.js';

class BadgesFactory {
    static createBadgesView(model){
        return new BadgesView({className: 'badges-container', model:model});
    }
}

export default BadgesFactory;